import { BookLink, Chapter, Reveal } from "./booking";

const DAYS = [
  { day: "Monday", name: "Educator Mondays" },
  { day: "Tuesday", name: "Tuesdays for Our Troops" },
  { day: "Wednesday", name: "Wednesdays for Our First Responders" },
  { day: "Thursday", name: "Student Thursdays" },
];

export default function Specials() {
  return (
    <section id="specials" data-testid="specials-section" className="px-5 lg:px-12 py-20 lg:py-32 border-t border-border bg-card">
      <Chapter index="04" title="Community Days" />
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
        <Reveal>
          <h2 className="font-display uppercase leading-[0.9] text-5xl sm:text-6xl lg:text-7xl">
            Every week,
            <br />
            <span className="text-primary">we give back.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="max-w-sm text-base leading-relaxed text-muted-foreground font-light">
            Community-focused specials for the people who keep Springfield running. Ask our team
            about today's special.
          </p>
        </Reveal>
      </div>

      <div className="grid md:grid-cols-2 gap-px bg-border border border-border">
        {DAYS.map((d, i) => (
          <Reveal key={d.name} delay={i * 0.07} className="bg-background p-8 lg:p-10 group hover:bg-secondary transition-colors duration-500">
            <p className="font-mono text-xs tracking-[0.3em] uppercase text-primary">{d.day}</p>
            <h3 className="font-display uppercase text-4xl sm:text-5xl leading-[0.95] mt-4 transition-transform duration-300 group-hover:translate-x-2">
              {d.name}
            </h3>
            <p className="mt-5 text-sm text-muted-foreground font-light">
              Ask our team about today's special.
            </p>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.2} className="mt-12 flex flex-col sm:flex-row gap-3">
        <BookLink testid="specials-book-button" className="btn-primary">
          Book on a Community Day
        </BookLink>
      </Reveal>
    </section>
  );
}
